import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('product')
export class Product {
  @JsonProperty('productName', String, true)
  public productName = '';

  @JsonProperty('consequences', String, true)
  public consequences = '';

  @JsonProperty('isADEProduct', Boolean, true)
  public isADEProduct = false;

  public get label(): string {
    return this.productName;
  }

  public get value(): string {
    return this.productName;
  }
}
